import type { CourseModule } from "@/core/types";
import { lektionZeichen } from "./lektion-01-zeichen";
import { lektionRahmen } from "./lektion-02-rahmen";
import { lektionTabstopps } from "./lektion-03-tabstopps";
import { lektionUmbruchsteuerung } from "./lektion-04-umbruchsteuerung";

/**
 * Die Formate der Registerkarte „Start“, die über fett, Abstände und Listen
 * hinausgehen. Tabstopps und „Seitenumbruch oberhalb“ kennt Office.js nicht –
 * diese Aufgaben prüft ein VBA-Prüfmakro.
 */
export const modulFeinschliff: CourseModule = {
  id: "feinschliff",
  title: "Zeichen- und Absatz-Feinschliff",
  summary:
    "Hoch- und Tiefstellen, Kapitälchen, Rahmen und Schattierung, Tabstopps mit " +
    "Füllzeichen und die Umbruchsteuerung – die Werkzeuge für ein sauberes Schriftbild.",
  level: "Grundlagen",
  lessons: [lektionZeichen, lektionRahmen, lektionTabstopps, lektionUmbruchsteuerung],
};
